export function buildTcnFilter(filters) {
    const map = new Map()

    for (const f of filters) {
        if (f.type === "PANEL") {
            buildFiters(f.children, map)
        } else {
            buildFilter(f, map)
        }
    }
    return map
}

function buildFiters(filters, map) {
    for (const f of filters) {
        buildFilter(f, map);
    }
}

function buildFilter(f, map) {
    if (f.mode === "RSQL") {
        let rsql = map.get(f.paramName) ? map.get(f.paramName) : ''
        if (f.type === "DATE-RANGE") {
            let value = ''
            switch (f.filter.length) {
                case 1:
                    value = f.selector + '==' + (f.workMode !== 'long' ? f.filter[0] : (new Date(f.filter[0])).getTime())
                    break;
                case 2:
                    value = f.selector + '=bt=(' + (f.workMode !== 'long' ? f.filter[0] : (new Date(f.filter[0])).getTime()) + ',' + (f.workMode !== 'long' ? f.filter[1] : (new Date(f.filter[1])).getTime()) + ')'
                    break;
                default:
                    value = null;
            }
            if (rsql && value) {
                rsql = rsql + ';' + value
            } else if (value) {
                rsql = value
            }
        } else if (f.elements) {
            if (rsql) {
                rsql = rsql + (parseInside(f) ? ';' + parseInside(f) : '')
            } else {
                rsql = parseInside(f)
            }
        } else if (f.filter || f.filter === false) {
            if (rsql) {
                rsql = rsql + ';' + f.selector + f.operator + `"` + f.filter + `"`
            } else {
                rsql = f.selector + f.operator + `"` + f.filter + `"`
            }
        }
        if (rsql) map.set(f.paramName, rsql)
    } else {
        if (f.filter || f.filter === false) {
            map.set(f.selector, f.filter)
        }
    }
}

function parseInside(f) {
    let value = ''
    for (const element of f.elements) {
        if (element.filter || f.filter === false) {
            value = value + f.selector + element.operator + `"` + element.filter + `"` + f.operator
        }
    }
    if (value !== '') {
        value = value.slice(0, -1)
        value = `(` + value + `)`
    }
    return value
}
